// extracted by mini-css-extract-plugin
export var languageModal = "languageSwitcher-module--languageModal--3nHt6";
export var languageModalInner = "languageSwitcher-module--languageModalInner--z3_3X";
export var modalCloseLink = "languageSwitcher-module--modalCloseLink--1fP3p";